import { useAuth } from '../contexts/AuthContext';
import BackToMars from './BackToMars';
import './Navbar.css';

export default function Navbar({ balance, totalAssets, onPortfolioClick, onCashClick }) {
  const { user, signOut } = useAuth();

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="navbar-brand">
          <h1 className="navbar-logo">VTrade</h1>
          <BackToMars />
        </div>
        <div className="navbar-right">
          <div className="navbar-balance clickable" onClick={onPortfolioClick}>
            <span className="balance-label">Total Assets</span>
            <span className="balance-value">${totalAssets.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>
          <div className="navbar-balance clickable" onClick={onCashClick}>
            <span className="balance-label">Cash</span>
            <span className="balance-cash">${balance.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
          </div>
          <div className="navbar-user">
            <span className="user-email">{user?.email}</span>
            <button onClick={signOut} className="btn-signout">Sign Out</button>
          </div>
        </div>
      </div>
    </nav>
  );
}
